import { useSession as useSessionOriginal } from '@mono/auth-react';

type User = {
  name: string | null;
  id: string;
  email: string | null;
  emailVerified: Date | null;
  image: string | null;
  createdAt: Date;
  updatedAt: Date;
};

export type OrganizationRoleValue = 'READ' | 'WRITE' | 'MAINTAIN' | 'ADMIN';

type Organization = {
  name: string;
  id: string;
  createdAt: Date;
  updatedAt: Date;
  slug: string;
  role: OrganizationRoleValue;
};

type Team = {
  name: string;
  id: string;
  organizationId: string;
};

type SessionData = {
  id: string;
  userId: string;
  expires: string;
  user: User;
  organizations: (Organization & {
    teams: Team[];
  })[];
};

const useSession = () => {
  return useSessionOriginal() as ReturnType<typeof useSessionOriginal> & {
    data: null | SessionData;
  };
};

export default useSession;
